<template>
  <div>
    <!-- Mobile App Bar -->
    <v-app-bar app color="white" flat class="mobileAppBar">
      <v-btn icon @click="mobileDrawer = true">
        <v-icon color="#3ea56e">mdi-menu</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <v-img
        src="@/assets/kl06logo.png"
        contain
        max-width="120"
        max-height="45"
      ></v-img>

      <v-spacer></v-spacer>
    </v-app-bar>

    <!-- Mobile Drawer -->
    <v-navigation-drawer
      v-model="mobileDrawer"
      temporary
      fixed
      left
      color="#3ea56e"
      class="mobileDrawer"
    >
      <div class="d-flex justify-end pa-3">
        <v-btn icon @click="mobileDrawer = false">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </div>

      <v-list dense>
        <v-list-item
          v-for="(item, i) in navItems"
          :key="'mobile-' + i"
          :to="item.route"
          router
          @click="mobileDrawer = false"
          :class="{ activeRoute: $route.path === item.route }"
        >
          <v-list-item-content>
            <v-list-item-title class="white--text text-uppercase">
              {{ item.name }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-layout wrap justify-center fill-height>
      <!-- Desktop Sidebar -->
      <v-flex xs12 sm12 md12 lg2 hidden-md-and-down>
        <v-navigation-drawer
          class="fixedSidebar"
          v-model="sideNav"
          clipped
          width="100%"
          height="100vh"
          permanent
          color="#3ea56e"
        >
          <v-layout wrap justify-center>
            <template v-for="(item, i) in navItems">
              <v-flex
                xs12
                :key="i"
                text-center
                py-2
                text-uppercase
                align-self-center
              >
                <v-layout wrap justify-center>
                  <v-flex xs12>
                    <router-link :to="item.route">
                      <span
                        :style="
                          $route.path === item.route
                            ? { fontFamily: 'poppinsbold' }
                            : { fontFamily: 'poppinslight' }
                        "
                        style="
                          font-size: 15px;
                          color: #ffffff;
                          letter-spacing: 3px;
                          cursor: pointer;
                        "
                      >
                        {{ item.name }}
                      </span>
                    </router-link>
                  </v-flex>

                  <v-flex xs12 pt-2 px-4>
                    <div style="border-bottom: 1px solid #ffffff"></div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </template>
          </v-layout>
        </v-navigation-drawer>
      </v-flex>

      <!-- Main Content -->
      <v-flex xs12 sm12 md12 lg10 pt-16 pt-md-0>
        <router-view></router-view>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      sideNav: true,
      mobileDrawer: false,

      navItems: [
        { name: "ANALYTICS", route: "/Seller" },
        { name: "ADD A PRODUCT", route: "/Seller/AddProduct" },
        { name: "PRODUCT SOLD", route: "/Seller/SoldProducts" },
        { name: "PENDING ORDERS", route: "/Seller/PendingOrders" },
        { name: "CANCELLED ORDERS", route: "/Seller/CancelledOrders" },
        { name: "INVENTORY REPORT", route: "/Seller/InventoryReport" },
        { name: "SALES REPORT", route: "/Seller/SalesReport" },
        { name: "INVENTORY", route: "/Seller/Inventory" },
        { name: "PRODUCT LIST", route: "/Seller/ProductList" },
        { name: "NOTIFICATIONS", route: "/Seller/Notification" },
        { name: "PROFILE", route: "/Seller/Profile" },
      ],
    };
  },
  computed: {
    appUser() {
      return this.$store.state.userData;
    }
  },
  watch: {
    appUser: {
      deep: true,
      immediate: true,
      handler() {
        this.updateTitle();
      }
    },
    $route: {
      immediate: true,
      handler() {
        this.updateTitle();
      }
    }
  },

  methods: {
    updateTitle() {
      if (this.appUser && (this.appUser.organization || this.appUser.firstname)) {
        const name = this.appUser.organization || this.appUser.firstname;
        document.title = `${name} | KL-06 FARM`;
      } else {
        document.title = "KL-06 FARM";
      }
    },
    changeRoute(item) {
      if (this.$route.query.styl !== item._id) {
        this.$router.push({
          path: "/Products",
          query: {
            styl: item._id,
            category: this.$route.query.category,
            subcategory: this.$route.query.subcategory,
            searchKey: this.$route.query.searchKey,
          },
        });
      } else {
        this.$router.push({
          path: "/Products",
          query: {
            styl: null,
            category: this.$route.query.category,
            subcategory: this.$route.query.subcategory,
            searchKey: this.$route.query.searchKey,
          },
        });
      }
    },
  },
};
</script>

<style>
@media only screen and (min-width: 1264px) {
  .mobileAppBar,
  .mobileDrawer {
    display: none !important;
  }

  .fixedSidebar {
    position: sticky;
    top: 0;
  }
}

@media only screen and (max-width: 1263px) {
  .fixedSidebar {
    display: none !important;
  }
}

.activeRoute {
  background-color: rgba(255, 255, 255, 0.2);
}

.mobileAppBar {
  z-index: 1000;
}

.v-list-item {
  min-height: 52px;
}
</style>